import { CheckBoxWrapper, CheckInput, CheckLabel, CheckPrice } from '@Components/common/Checkbox';
import usePrice from '@Hooks/usePrice';
import useTranslation from 'next-translate/useTranslation';
import Image from 'next/image';
import Delete from 'public/delete.svg';
import Logo from 'public/logo.svg';
import RedCheck from 'public/red-check.svg';
import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Dispatch } from 'store';
import { AddToCartParams, CartProduct } from 'types/Cart';
import {
  Button,
  Card,
  CheckBoxesWrapper,
  Count,
  DeleteIcon,
  Discount,
  Div,
  FlexCenter,
  Header,
  Info,
  PartImage,
  Price,
  PriceWrapper,
  Title,
  Total,
  Wrapper,
} from './CartProductCard.styled';

type Props = {
  data: CartProduct;
};
export default function PartCard({ data }: Props) {
  const { t } = useTranslation('Cart');
  const { thePrice: price } = usePrice(data.product.price);
  const { thePrice: specialPrice } = usePrice(data.product.special_price || 0);
  const { thePrice: priceWithQuantity } = usePrice(data.product.price * data.quantity);
  const { thePrice: specialPriceWithQuantity } = usePrice(
    data.product.special_price ? data.product.special_price * data.quantity : 0
  );
  const { thePrice: installationPrice } = usePrice(data.product.installation_price || 0);
  const [isLoading, setIsLoading] = useState(false);
  const {
    cart: { deleteProductFromCart, updateProductInCart },
  } = useDispatch<Dispatch>();

  const handleDelete = useCallback(
    (productId: number) => {
      setIsLoading(true);
      deleteProductFromCart(productId).then(() => {
        setIsLoading(false);
      });
    },
    [deleteProductFromCart]
  );
  const handleUpdateProduct = useCallback(
    (params: AddToCartParams) => {
      setIsLoading(true);
      updateProductInCart(params).then(() => {
        setIsLoading(false);
      });
    },
    [updateProductInCart]
  );

  return (
    <Card isLoading={isLoading}>
      <PartImage>
        <Image src={data.product.images?.[0].url || Logo} alt={data.product.name} layout="fill" objectFit="cover" />
      </PartImage>
      <Div>
        <Header>
          <Div>
            <Title>{data.product.name}</Title>
            <Info>{data.product.description}</Info>
            <PriceWrapper>
              {data.product.special_price && data.product.price !== data.product.special_price && (
                <Discount>{Math.ceil(100 - (100 * data.product.special_price) / data.product.price)}%</Discount>
              )}
              <Price>{data.product.special_price && data.product.price !== data.product.special_price && price}</Price>
            </PriceWrapper>
          </Div>
          <Wrapper>
            <FlexCenter>
              <Button
                plus
                onClick={() =>
                  handleUpdateProduct({
                    product_id: data.product.id,
                    quantity: data.quantity + 1,
                  })
                }
              />
              <Count>{data.quantity}</Count>
              {data.quantity === 1 ? (
                <DeleteIcon onClick={() => handleDelete(data.product.id)}>
                  <Image src={Delete} width={8.94} height={11.69} alt="delete icon" />
                </DeleteIcon>
              ) : (
                <Button
                  onClick={() =>
                    handleUpdateProduct({
                      product_id: data.product.id,
                      quantity: data.quantity - 1,
                    })
                  }
                />
              )}
            </FlexCenter>
            <Total>
              {data.product.special_price && data.product.price !== data.product.special_price
                ? specialPriceWithQuantity
                : priceWithQuantity}
            </Total>
          </Wrapper>
        </Header>
        <CheckBoxesWrapper>
          {Boolean(data.product.installation_price) && (
            <CheckBoxWrapper>
              <CheckInput
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  handleUpdateProduct({
                    product_id: data.product.id,
                    quantity: data.quantity,
                    need_installation: e.target.checked,
                  })
                }
                name={'need_installation_' + data.product.id}
                id={'need_installation_' + data.product.id}
                type="checkbox"
                checked={data.need_installation}
              />
              <CheckLabel htmlFor={'need_installation_' + data.product.id}>
                {t('installation')}
                {data.need_installation && <Image src={RedCheck} width={12.3} height={8.8} alt="check" />}
              </CheckLabel>
              <CheckPrice>
                {data.need_installation
                  ? data.quantity > 1
                    ? installationPrice + ' ' + t('per-item')
                    : installationPrice
                  : '-'}
              </CheckPrice>
            </CheckBoxWrapper>
          )}
          <CheckBoxWrapper>
            <CheckInput
              onChange={() =>
                handleUpdateProduct({
                  product_id: data.product.id,
                  quantity: data.quantity,
                  // need_installation: data.need_installation,
                  need_pickup: false,
                })
              }
              id={'can_picked_up_' + data.product.id}
              type="radio"
              name={'can_picked_up_' + data.product.id}
              checked={!data.need_pickup}
            />
            <CheckLabel htmlFor={'can_picked_up_' + data.product.id} isRadio={true}>
              {t('delivery')}
            </CheckLabel>
          </CheckBoxWrapper>
          {data.product.can_picked_up && (
            <CheckBoxWrapper>
              <CheckInput
                onChange={() =>
                  handleUpdateProduct({
                    product_id: data.product.id,
                    quantity: data.quantity,
                    // need_installation: data.need_installation,
                    need_pickup: true,
                  })
                }
                id={'Pick_can_picked_up_' + data.product.id}
                type="radio"
                name={'can_picked_up_' + data.product.id}
                checked={data.need_pickup}
              />

              <CheckLabel htmlFor={'Pick_can_picked_up_' + data.product.id} isRadio={true}>
                {t('near_branch')}
              </CheckLabel>
            </CheckBoxWrapper>
          )}
        </CheckBoxesWrapper>
      </Div>
    </Card>
  );
}
